import { useScrollAnimation, useStaggerAnimation } from '../../../hooks/useScrollAnimation';

const beneficios = [
  {
    icon: 'ri-money-dollar-circle-line',
    title: 'Redução Real de Custos',
    description: 'Identifique coberturas desnecessárias, negocie comissões e pague exatamente o que o seu risco exige.',
  },
  {
    icon: 'ri-shield-check-line',
    title: 'Proteção de Verdade',
    description: 'Pare de contratar apólices que parecem boas mas deixam brechas na hora que você mais precisa.',
  },
  {
    icon: 'ri-alarm-warning-line',
    title: 'Zero Surpresas no Sinistro',
    description: 'Conheça exatamente o que está coberto antes de contratar — e elimine o risco de ser surpreendido.',
  },
  {
    icon: 'ri-bar-chart-grouped-line',
    title: 'Comparação Técnica de Propostas',
    description: 'Avalie cotações com critério real, além do preço: coberturas, franquias, exclusões e cláusulas-chave.',
  },
  {
    icon: 'ri-shake-hands-line',
    title: 'Poder de Negociação',
    description: 'Com conhecimento técnico, você negocia em pé de igualdade e obtém condições melhores na renovação.',
  },
  {
    icon: 'ri-checkbox-circle-line',
    title: 'Segurança na Decisão',
    description: 'Decida com confiança, sem pressão comercial. Você saberá exatamente por que está escolhendo cada apólice.',
  },
];

export default function BeneficiosMetodo() {
  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation();
  const { ref: gridRef, visibleItems } = useStaggerAnimation(beneficios.length);
  const { ref: ctaRef, isVisible: ctaVisible } = useScrollAnimation();

  return (
    <section
      id="beneficios-metodo"
      className="py-16 sm:py-20 lg:py-28 bg-white"
      aria-labelledby="beneficios-metodo-heading"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Cabeçalho */}
        <div
          ref={headerRef as React.RefObject<HTMLDivElement>}
          className={`text-center mb-12 sm:mb-16 transition-all duration-700 ease-out ${headerVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <div className="inline-flex items-center gap-2 bg-teal-100 px-4 py-2 rounded-full mb-4 sm:mb-6">
            <i className="ri-gift-line text-teal-600 text-base" aria-hidden="true"></i>
            <span className="text-teal-700 font-bold text-xs sm:text-sm uppercase tracking-wide">O Que Você Ganha</span>
          </div>
          <h2
            id="beneficios-metodo-heading"
            className="text-3xl sm:text-4xl lg:text-5xl font-bold text-petrol-900 mb-4 sm:mb-6 px-4"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Resultados concretos para{' '}
            <span className="text-teal-600">quem aplica o método</span>
          </h2>
          <p className="text-base sm:text-lg text-petrol-700 max-w-3xl mx-auto leading-relaxed px-4">
            O <strong className="text-petrol-900">Método de Contratação Ativa</strong> transforma a forma como você
            contrata seguros — reduzindo custos, ampliando proteção e eliminando decisões no escuro.
          </p>
        </div>

        {/* Grid de cards */}
        <div
          ref={gridRef as React.RefObject<HTMLDivElement>}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-12 sm:mb-16"
        >
          {beneficios.map((item, index) => (
            <div
              key={index}
              className={`bg-white rounded-xl sm:rounded-2xl p-6 sm:p-8 border border-teal-100 hover:border-teal-400 group cursor-default transition-all duration-700 ease-out ${visibleItems[index] ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
            >
              <div className="w-14 h-14 bg-gradient-to-br from-teal-500 to-teal-600 rounded-xl flex items-center justify-center mb-4 sm:mb-6 group-hover:scale-110 transition-transform">
                <i className={`${item.icon} text-2xl sm:text-3xl text-white`} aria-hidden="true"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-petrol-900 mb-3 sm:mb-4 group-hover:text-teal-600 transition-colors leading-tight">
                {item.title}
              </h3>
              <p className="text-sm sm:text-base text-petrol-700 leading-relaxed">
                {item.description}
              </p>
            </div>
          ))}
        </div>

        {/* Barra de impacto */}
        <div
          ref={ctaRef as React.RefObject<HTMLDivElement>}
          className={`bg-gradient-to-r from-teal-600 to-teal-700 rounded-xl sm:rounded-2xl p-6 sm:p-10 text-center transition-all duration-700 ease-out ${ctaVisible ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-8 scale-95'}`}
        >
          <p className="text-sm sm:text-base text-teal-100 uppercase tracking-widest font-semibold mb-3">
            Mais de 4.800 segurados já transformaram sua contratação
          </p>
          <h3
            className="text-xl sm:text-2xl lg:text-3xl font-bold text-white mb-3 sm:mb-4 px-2"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Você pode pagar menos e estar muito mais protegido
          </h3>
          <p className="text-sm sm:text-base text-teal-100 mb-6 sm:mb-8 max-w-2xl mx-auto px-4">
            Acesse o método completo por apenas{' '}
            <strong className="text-white">R$67</strong>. Aplicação imediata, resultado real.
          </p>
          <a
            href="#analise-gratuita"
            className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-white text-teal-700 text-base sm:text-lg font-bold rounded-lg hover:bg-teal-50 transition-all duration-300 whitespace-nowrap"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-circle-line text-teal-700 text-lg" aria-hidden="true"></i>
            </div>
            Quero acessar o método agora →
          </a>
          <p className="text-xs text-teal-200 mt-3">Sem risco. Acesso imediato.</p>
        </div>

      </div>
    </section>
  );
}
